import { Autocomplete, Box, TextField, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { Controller, useForm, useWatch } from 'react-hook-form';

import { ParameterClass, ParameterSetDisposition } from '~pages/SipConfiguration/domain';

import { ContactFlowNodeProps } from '..';
import BaseNode from '../BaseNode';

export default function SetDispositionNode(props: ContactFlowNodeProps) {
  const form = useForm<ParameterSetDisposition>({
    defaultValues: props.data.parameter.setDisposition,
  });
  return (
    <BaseNode
      {...props}
      title='Set Disposition'
      parameterForm={form}
      renderParameterForm={(setDisposition) => (
        <>
          <Typography>Code: {setDisposition?.code || '--'}</Typography>
          <Typography>Subcode: {setDisposition?.subCode || '--'}</Typography>
          <Typography>Exclusion List: {setDisposition?.exclusionList || '--'}</Typography>
          <Typography>
            Callback Endpoint Source Class: {setDisposition?.callback?.endpointSourceClass || '--'}
          </Typography>
          <Typography>
            Callback Endpoint Source Field: {setDisposition?.callback?.endpointSourceField || '--'}
          </Typography>
        </>
      )}
      transformParameter={(setDisposition) => ({ setDisposition })}
      renderEditParameter={({ control, setValue }) => {
        const setDisposition = useWatch({
          control,
        });
        const hideValue = setDisposition?.callback?.endpointSourceClass == ParameterClass.CmpDTMF;
        useEffect(() => {
          if (setDisposition.exclusionList === '') {
            setValue('exclusionList', null);
          }
          if (setDisposition.callback?.endpointSourceClass === null) {
            setValue('callback', null);
          } else if (hideValue && setDisposition.callback?.endpointSourceField !== '') {
            setValue('callback.endpointSourceField', '');
          }
        }, [setDisposition]);

        return (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
            }}>
            <Controller
              control={control}
              name='code'
              defaultValue=''
              render={({ field }) => <TextField {...field} fullWidth label='Code' />}
            />
            <Controller
              control={control}
              name='subCode'
              defaultValue=''
              render={({ field }) => <TextField {...field} fullWidth label='Subcode' />}
            />
            <Controller
              control={control}
              name='exclusionList'
              defaultValue={null}
              render={({ field: { value, ...rest } }) => (
                <TextField {...rest} fullWidth label='Exclusion List' value={value ?? ''} />
              )}
            />
            <Controller
              control={control}
              name='callback.endpointSourceClass'
              render={({ field: { value, onChange, ...rest }, fieldState: { error } }) => (
                <Autocomplete
                  {...rest}
                  fullWidth
                  options={[...Object.values(ParameterClass)]}
                  renderInput={(params) => <TextField {...params} label='Callback Endpoint Source Class' />}
                  value={value || null}
                  onChange={(e, v) => {
                    onChange(v);
                  }}
                />
              )}
            />
            {setDisposition.callback?.endpointSourceClass && !hideValue && (
              <Controller
                control={control}
                name='callback.endpointSourceField'
                defaultValue=''
                render={({ field: { value, ...rest } }) => (
                  <TextField {...rest} fullWidth label='Callback Endpoint Source Field' value={value ?? ''} />
                )}
              />
            )}
          </Box>
        );
      }}
    />
  );
}
